import { createAction } from 'redux-actions'

export const getMealDetail = createAction('GET_MEAL_DETAIL_STARTED')
export const getMealDetailSuccess = createAction('GET_MEAL_DETAIL_SUCCEED')
export const getMealDetailFail = createAction('GET_MEAL_DETAIL_FAILED')



// WEBPACK FOOTER //
// ./src/store/actions/mealDetail.js